import { render, staticRenderFns } from "./r-task-config.vue?vue&type=template&id=dc0be40e"
import script from "./r-task-config.vue?vue&type=script&lang=js"
export * from "./r-task-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc0be40e')) {
      api.createRecord('dc0be40e', component.options)
    } else {
      api.reload('dc0be40e', component.options)
    }
    module.hot.accept("./r-task-config.vue?vue&type=template&id=dc0be40e", function () {
      api.rerender('dc0be40e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-task-config.vue"
export default component.exports